<template>
    <v-app id="splash">
        <v-container fluid>
             <v-layout justify-center row class="mt-lg-0 mt-10">

                 <v-flex lg12 xs8 class="mt-lg-16 pt-lg-16 mt-16 ml-lg-0">
                     
                    <v-img src="../../assets/images/LevelTest/reports/mega_blue.png" aspect-ratio="1" class="logo-size " contain></v-img>
                
                 </v-flex>

                 <v-flex lg12 xs12 class="text-center mt-lg-16">

                 
                     <!-- <a href="/leveltest"> -->
                        <v-btn class="mx-2" fab dark color="primary" @click="nextpage()">
                            <v-icon dark class="text-lg-h2">
                                mdi-chevron-right
                            </v-icon>
                        </v-btn>
                     <!-- </a> -->
                     

                 </v-flex>

             </v-layout>
        </v-container>
    </v-app>
</template>
<style scoped>
#splash{
    background: radial-gradient(472.77% 67.8% at 50% 15.55%, #FFFFFF 20.83%, #8BDCFF 100%);
}
.logo-size{
    height:300px;
}
@media only screen and (max-width: 1200px) {
  .logo-size{
    height:250px;
    width:250px;
}
}
</style>
<script>
export default {
   methods:{
        nextpage(){
            // window.location.href="/previewMaterial?l_id="+this.$route.query.l_id
            this.$router.push({name:'PreviewMaterial',params:{l_id:this.$route.params.l_id}})
        }
    }
}
</script>